import { html, TemplateResult } from "lit-html";
import CloseButtonTemplate from '@libs/modal/closeButton';
import FormTemplate from "./form";

const UpdatePasswordTemplate = (props: IUpdatePasswordModel): TemplateResult => {
  const {
    messages,
    close
  } = props;

  return html`
    <div class="proposal">
      ${CloseButtonTemplate(close)}
      <div class="modal-body confirm-subscription">
        <div class="add-pwd">
          <p class="add-pwd-title">${messages.JobSeekerConfirmDialogProfileTitle}</p>
          <p class="subtitle">${messages.JobSeekerConfirmDialogAddPasswordTitle}</p>
          ${FormTemplate(props)}
        </div>
      </div>
    </div>
    `;
}

export default UpdatePasswordTemplate;